export const Create = () => import('./Create.vue');
export const Edit = () => import('./Edit.vue');
export const View = () => import('./View.vue');
export const List = () => import('./List.vue');
